import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

const CatalogPreviewItemSchema = z.object({
  id: z.string(),
  title: z.string(),
  subtitle: z.string().nullable(),
  description: z.string().nullable(),
  kind: z.string(),
  grain: z.string().nullable(),
  details: z.unknown(),
});

export const getCustomAnalyticsSelectableCatalogPreview = unaryRpc({
  name: "getCustomAnalyticsSelectableCatalogPreview" as const,
  input: z.object({ fieldRefs: z.array(z.string()), grain: z.string() }),
  output: z.object({ items: z.array(CatalogPreviewItemSchema) }),
});

export type GetCustomAnalyticsSelectableCatalogPreviewInput = z.infer<
  typeof getCustomAnalyticsSelectableCatalogPreview.input
>;
export type GetCustomAnalyticsSelectableCatalogPreviewOutput = z.infer<
  typeof getCustomAnalyticsSelectableCatalogPreview.output
>;
